// extracted by mini-css-extract-plugin
export default {"emoji":"Emoji-module--emoji--bbc2d"};